import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import {
  coolGrey,
  greyStroke,
  modernSalmon,
  modernSalmonBackground,
  softBlue,
  softBlueLight,
  softGreen,
  softGreenLight,
} from 'lib/css/colors';
import DataSourceRunStatus from 'lib/enums/DataSourceRunStatus';

const styles = StyleSheet.create({
  badge: {
    padding: '4px 10px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
    display: 'inline-block',
    textTransform: 'capitalize',
  },
  badgeSuccess: {
    backgroundColor: softGreenLight,
    color: softGreen,
  },
  badgeFailed: {
    backgroundColor: modernSalmonBackground,
    color: modernSalmon,
  },
  badgeRunning: {
    backgroundColor: softBlueLight,
    color: softBlue,
  },
  badgeUnknown: {
    backgroundColor: greyStroke,
    color: coolGrey,
  },
});

const STATUS_BADGE_STYLES = {
  [DataSourceRunStatus.SUCCESS]: styles.badgeSuccess,
  [DataSourceRunStatus.FAILED]: styles.badgeFailed,
  [DataSourceRunStatus.RUNNING]: styles.badgeRunning,
};

function StatusPill({ status }) {
  const statusStyle = STATUS_BADGE_STYLES[status];

  return (
    <span className={css(styles.badge, statusStyle ?? styles.badgeUnknown)}>
      {statusStyle ? status : '-'}
    </span>
  );
}

StatusPill.propTypes = {
  status: PropTypes.oneOf(Object.values(DataSourceRunStatus)),
};

StatusPill.defaultProps = {
  status: undefined,
};

export default StatusPill;
